export const Location = {
    map: 'location.map',
    add: 'location.add',
    change: 'location.change',
    delete: 'location.delete',
    position: 'location.position',
    edit: 'location.edit',
    move: 'location.move',
    favourite: 'location.favourite',
};

export const StartHour = {
    change: 'start-hour.change',
};
